import React from "react";
import { Box } from "@chakra-ui/react";

const Percentage = ({ value, column }) => {
  return (
    <Box
      display={{ base: "inline", md: "block" }}
      w={{ base: "auto", md: "100%" }}
      textAlign={"right"}
      data-testid="percentage-box"
    >
      {column.emptyReplace && !value ? column.emptyReplace : `${value}%`}
    </Box>
  );
};

export default Percentage;
